export default [
  {
    path: '/package/identity-v',
    name: 'list-identity-v-package',
    component: () => import('@/views/identityV/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      resource: 'identity-v',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/package/identity-v/create',
    name: 'create-identity-v-package',
    component: () => import('@/views/identityV/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      navActiveLink: 'list-identity-v-package',
      resource: 'identity-v',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          to: { name: 'list-identity-v-package' },
        },
        {
          text: 'breadcrumb.createPackage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/package/identity-v/:id/update',
    name: 'update-identity-v-package',
    component: () => import('@/views/identityV/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      navActiveLink: 'list-identity-v-package',
      resource: 'identity-v',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          to: { name: 'list-identity-v-package' },
        },
        {
          text: 'breadcrumb.updatePackage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/package/identity-v/:id',
    name: 'view-identity-v-package',
    component: () => import('@/views/identityV/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      navActiveLink: 'list-identity-v-package',
      resource: 'identity-v',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          to: { name: 'list-identity-v-package' },
        },
        {
          text: 'breadcrumb.viewPackage',
          active: true,
        },
      ],
    },
  },
]
